// Motiv-Erkennung aus Dateinamen: „Paddington_Herbst_300x250_v2“ und „Paddington Herbst 728x90“
// gehören zum selben Motiv „Paddington Herbst“ – nur Format und Versionszusatz unterscheiden sich.

const SIZE = /(?:^|[\s_.-])\d{2,4}\s*[x×X]\s*\d{2,4}(?=$|[\s_.-])/g;
const NOISE =
  /(?:^|[\s_.-])(?:v(?:er(?:sion)?)?\s?\d+|rev\s?\d+|final|finale|html5?|gif|jpe?g|png|webp|mp4|mov|webm|zip|backup|fallback|static|animated)(?=$|[\s_.-])/gi;

/** Lesbarer Motivname ohne Format- und Versionsangaben; leer, wenn nur ein Format übrig bliebe. */
export function motifName(name: string): string {
  return name
    .replace(SIZE, ' ')
    .replace(NOISE, ' ')
    .replace(/[_]+/g, ' ')
    .replace(/\s*[-–·]\s*$/g, '')
    .replace(/^\s*[-–·]\s*/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Schlüssel zum Gruppieren nach Motiv (Groß-/Kleinschreibung und Trennzeichen egal). */
export function motifKey(name: string): string {
  return motifName(name)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
